import { createFrontendModule } from '@backstage/frontend-plugin-api';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';

export const essityApiDocsOverridesModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    apiDocsPlugin.getExtension('entity-card:api-docs/has-apis').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            loader: async () => {
              return import('../components/cards').then(m => (
                <m.EssityHasApisCard />
              ));
            },
          },
        });
      },
    }),
  ],
});
